export default __webpack_public_path__ + "static/media/1.3bd9e7d6.png";